export default __webpack_public_path__ + "static/media/speech active.5483857e.svg";